// use FerrisWheelSpinnerOverlay
import React from 'react';
import { FerrisWheelSpinnerOverlay } from "react-spinner-overlay";
import { useTranslation } from 'translation/useTranslation';

export default function FullPageLoader({show, translation = { key: 'global.loading.loading', default: 'Wird geladen...' }}) {
  const { editableTranslate } = useTranslation();

  // The overlay is a third-party component with a fixed prop set, so the handle
  // goes on an element of ours. It only carries a name while the loader is up:
  // a permanently present `full-page-loader` would assert nothing.
  const loaderTestId = show ? 'full-page-loader' : undefined;

  return (
    <div data-testid={loaderTestId}>
      <FerrisWheelSpinnerOverlay
        loading={show}
        color="#003366"
        message={
          <span className="mt-3">{editableTranslate(translation.key, translation.default)}</span>

        }
        zIndex={9998}
      />
    </div>
  );
}